
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import '../elements/loading-curtain';
import { scripter } from '../modules/scripter';
import { styler } from '../modules/styler';
import { PublicAppElement } from './public-app-element';
const deCacheToken = '&deCacheToken=';
// Landing page widget content loader implementation.  Whenever the URL property is changed, the content will be reloaded from the new URL.
export class PublicAppContentLoader extends PublicAppElement {
    private _url: string = '';
    private _widgetId: string = '';
    private _responseText: string = '';
    private isFirstLoad = true;

    // Begin getters and setters for properties
    get url(): string {
        return this._url;
    }

    @property({ type: String })
    set url(value: string) {
        const oldValue = this._url;
        this._url = value;
        this.requestUpdate('url', oldValue);

        this.showLoadingCurtain();
        // URL is updated, so trigger a reload
        // Let the page come back fast, the widgets may continue to load later
        setTimeout(() => { this.reload(); }, this.isFirstLoad ? 1000 : 0);
    }

    get widgetId(): string {
        return this._widgetId;
    }

    @property({ type: String })
    set widgetId(value: string) {
        const oldValue = this._widgetId;
        this._widgetId = value;
        this.requestUpdate('widgetId', oldValue);
    }
    // End getters and setters for properties

    getLoadingCurtain() {
        return this.shadowRoot?.querySelector("loading-curtain");
    }

    showLoadingCurtain() {
        if (this.isFirstLoad) return;
        let lc = this.getLoadingCurtain();
        if (lc) {
            lc.classList.add("short");
            lc.parentElement?.classList.add("form-floating");
            lc.opened = true;
        }
    }

    hideLoadingCurtain() {
        this.isFirstLoad = false;
        let lc = this.getLoadingCurtain();
        if (lc) {
            lc.classList.remove("short");
            lc.parentElement?.classList.remove("form-floating");
            lc.opened = false;
        }
    }

    // A place holder.  We need this content to properly reserve the space for the content in the widget
    render() {
        return html`
            <link rel="stylesheet" href="/css/global.css?v=${this.appVersion}">
            <div>
                <div id="content_loader_container" class="content_loader_container widget${this._widgetId}-container" data-widget-id=${this.widgetId}><img src="/images/loading.gif" style="padding-left:46%"></img></div>
                <loading-curtain id="lp-loading-curtain" ?opened=${false}></loading-curtain>
            </div>
        `;
    }

    // Fetch data from the current URL and display as the content
    async reload() {
        this.showLoadingCurtain();
        let curUrl = this.getFormattedUrl();
        console.log("Loading Public App Content Loader", curUrl, new Date());
        if (!curUrl || curUrl.length == 0) {
            return;
        }
        // Get the formatted URL (add a query string to avoid cache) and fetch the result
        const response = await fetch(curUrl),
            responseText = await response.text();
        // Create a new div element and add the content to it
        const fragment = this.shadowRoot?.querySelector('#content_loader_container') as any;
        if (fragment) {



            //SREE-TODO - Remove responseText.replace with just responseText after fixing all xmls
            let content = this.getContentHtml(this.getFormattedResponseText(responseText));



            let allScripts = this.getScripts(content);
            let allStyles = this.getStyles(content)
            fragment.textContent = "";
            fragment.appendChild(content);
            await this.applyScriptsAndStyles(allScripts, allStyles);
            this.hideLoadingCurtain();
        } else {
            this._responseText = this.getFormattedResponseText(responseText);
            let that = this;
            setTimeout(() => { that.loadContent(); }, 1000);
        }

        // Div is ready to be shown now, remove all children now and immediately add the new div to avoid flickering
        //this.childNodes.forEach(e => e.remove());
        //this.appendChild(fragment);
    }

    getFormattedResponseText(responseText: any) {
        let retVal = responseText.replaceAll("fetch(", "fetchPage(");
        return retVal;
    }

    loadContent() {
        console.log("Retrying to set response text to content loader..")
        const fragment = this.shadowRoot?.querySelector('#content_loader_container') as any;
        if (fragment) {
            fragment.textContent = "";
            fragment.appendChild(this.getContentHtml(this._responseText));
        } else {
            let that = this;
            setTimeout(() => { that.loadContent(); }, 1000);
        }
    }

    // Returns a random number.  This is used to avoid retrieving the content from cache.
    getRandomNum() {
        return Math.floor(Math.random() * 5000);
    }

    //Parse the url, remove decache token, then add it with new random number
    getFormattedUrl() {
        var curUrl = this._url;
        const rand = this.getRandomNum()
        if (curUrl.indexOf('?') == -1) {
            curUrl = curUrl + "?rand=" + rand;
        } else {
            curUrl = curUrl + "&rand=" + rand;
        }
        return curUrl;
    }
    getStyles(source: HTMLElement) {
        let styleElements: HTMLStyleElement[] = [];
        const scopedId = source.querySelector("main")?.getAttribute("id") as string;
        for (let s of source.querySelectorAll("style")) {
            s.parentElement?.removeChild(s);
            let css: HTMLStyleElement | void;
            css = styler(s, scopedId);
            if (css) {
                styleElements.push(css);
            } else {
                styleElements.push(s);
            }
        }
        return styleElements
    }
    getScripts(content: HTMLElement) {
        let scriptElements: HTMLScriptElement[] = []
        for (let s of content.querySelectorAll("script")) {

            let script: HTMLScriptElement | void;

            if (s.hasAttribute("noscript")) {
                s.parentElement?.removeChild(s);
                continue;
            }

            if (s.hasAttribute("src")) {
                scriptElements.push(s);
                s.parentElement?.removeChild(s);
                continue;
            }
            if (script = scripter(s)) {
                scriptElements.push(script);
                s.parentElement?.removeChild(s);
                continue;
            }
        }
        return scriptElements;
    }
    async applyScriptsAndStyles(scriptElements: any, allStyles: any) {
        allStyles.forEach(s => {
            this.appendChild(s);
        });
        let promiseArray = [] as Promise<any>[];
        for (const s of scriptElements) {
            if (s.hasAttribute("src")) {
                if (s.getAttribute("src")) {
                    promiseArray.push(this.loadJavaScript(s.getAttribute("src")));
                    this.appendChild(s);
                }
            } else {
                await Promise.all(promiseArray);
                promiseArray = [];
                var e = document.createElement("script");
                var inlineScript = document.createTextNode(s.text);
                e.appendChild(inlineScript);
                try {
                    this.appendChild(e);
                } catch (e) {

                }
            }
        }
        await Promise.all(promiseArray);
    }
    async loadJavaScript(url: any) {
        const versionedUrl = url + "?v=" + this.appVersion;
        let alreadyLoaded = document.querySelectorAll("script[src='" + versionedUrl + "']")[0];
        if (alreadyLoaded) {
            return new Promise((resolve, reject) => { resolve(true); });
        }
        let promise = new Promise((resolve, reject) => {
            window["jQuery"].ajax({
                url: versionedUrl,
                dataType: 'script',
                cache: true,
                success: () => { resolve(true); },
                error: () => { reject('Ajax request failed'); }
            });
        });
        return promise;
    }

}
declare global {
    interface HTMLElementTagNameMap {
        'public-app-content-loader': PublicAppContentLoader;
    }
}

